<template>
  <div class="position-relative">
    <div class="breadcrumb-container">
      <b-breadcrumb :items="breadcrumb_items"></b-breadcrumb>
    </div>
    <div id="crequestcontainer" v-if="customFields.length">
      <h2 class="mb-3 text-center text-decoration-underline">Edit Request</h2>
      <div class="d-flex flex-column">
        <div class="row">
          <div class="form-group col-6">
            <label for="projectname" class="form__label">
              Project Name
              <span class="text-danger">*</span>
            </label>
            <div class="d-flex">
              <strong>{{ projectname }}</strong>
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.cryptotype.$error }"
          >
            <label for="cryptotype" class="form__label">
              Crypto Type
              <span class="text-danger">*</span>
            </label>
            <multiselect
              v-model="cryptotype"
              :options="crypto_types"
              placeholder="Select Crypto Type"
            ></multiselect>
            <div class="error" v-if="$v.cryptotype.$error">
              Crypto type is required
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.variant_name.$error }"
          >
            <label for="variantname">
              Variant
              <span class="text-danger">*</span>
            </label>
            <multiselect
              v-model="variant_name"
              :options="variants"
              multiple
              placeholder="Select Variant"
            ></multiselect>
            <div class="error" v-if="$v.variant_name.$error">
              Variant Name is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.carrier_name.$error }"
          >
            <label>
              Carrier
              <span class="text-danger">*</span>
            </label>
            <multiselect
              v-model="carrier_name"
              :options="carriers"
              placeholder="Select Carrier"
            ></multiselect>
            <div class="error" v-if="$v.carrier_name.$error">
              Carrier is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.threat_actor_email_address.$error,
            }"
          >
            <label>
              Threat Actor Email Address
              <span class="text-danger" v-if="tor_chat_link === ''">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="threat_actor_email_address"
              @change="$v.threat_actor_email_address.$touch"
            />
            <div
              class="error"
              v-if="
                $v.threat_actor_email_address.$error &&
                !$v.threat_actor_email_address.required
              "
            >
              Either Threat actor Email address / Tor Chat Link is required
            </div>
            <div
              class="error"
              v-else-if="
                $v.threat_actor_email_address.$error &&
                !$v.threat_actor_email_address.email
              "
            >
              Please enter a valid Email
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.tor_chat_link.$error }"
          >
            <label for="torchatlink"
              >TOR Chat Link
              <span class="text-danger" v-if="threat_actor_email_address === ''"
                >*</span
              ></label
            >
            <input
              name="torchatlink"
              type="text"
              class="form-control"
              v-model="tor_chat_link"
            />
            <div class="error" v-if="$v.tor_chat_link.$error">
              Either Threat actor Email address / Tor Chat Link is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.client_domain_name.$error }"
          >
            <label for="clientdomainname">
              Domain name of Client
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              name="clientdomainname"
              v-model="client_domain_name"
            />
            <div class="error" v-if="$v.client_domain_name.$error">
              Domain name of Client is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.ransom_payment_reason.$error }"
          >
            <label for="ransompaymentreason" class="">
              Ransom Payment Reason <span class="text-danger">*</span></label
            >
            <multiselect
              v-model="ransom_payment_reason"
              :options="ransom_payment_reasons"
              placeholder="Select Ransom Payment Reason"
            ></multiselect>
            <div class="error" v-if="$v.ransom_payment_reason.$error">
              Ransom Payment Reason is required
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.crypto_original_ransom_demand.$error,
            }"
          >
            <label for="cryptooriginalransomdemand">
              Crypto Original Ransom Demand
              <span class="text-danger" v-if="original_ransom_demand === ''"
                >*</span
              >
              <template v-if="currencyUnit !== ''"
                >({{ currencyUnit }})</template
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="cryptooriginalransomdemand"
              id="cryptooriginalransomdemand"
              v-model="crypto_original_ransom_demand"
            />
            <div class="error" v-if="$v.crypto_original_ransom_demand.$error">
              Either Crypto Original Ransom Demand/ Dollars is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.original_ransom_demand.$error,
            }"
          >
            <label for="OriginalRansomDemand">
              Original Ransom Demand
              <span
                class="text-danger"
                v-if="crypto_original_ransom_demand === ''"
                >*</span
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="OriginalRansomDemand"
              id="OriginalRansomDemand"
              v-model="original_ransom_demand"
            />
            <div class="error" v-if="$v.original_ransom_demand.$error">
              Either Crypto Original Ransom Demand/ Dollars is required
            </div>
          </div>
          <div
            class="form-group col-12"
            :class="{
              'form-group--error': $v.initial_ransom_payment_files.$error,
            }"
          >
            <label>
              Initial Ransom Demand Screenshots(jpg/png)
              <span class="text-danger">*</span>
            </label>
            <div
              v-for="index in initial_ransom_payment_files.length + 1"
              :key="index"
            >
              <FileUpload
                @fileSelected="initialRansomFileSelected"
                @fileRemoved="initialRansomFileRemoved"
                :unique-key="`initialransomfile${index}`"
              />
            </div>
            <div
              class="error"
              v-if="
                !$v.initial_ransom_payment_files.required &&
                $v.initial_ransom_payment_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.initial_ransom_payment_files.$error &&
                !$v.initial_ransom_payment_files.unique
              "
            >
              Files must be unique
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.crypto_negotiated_ransom_demand.$error,
            }"
          >
            <label for="cryptonegotiatedransomdemand">
              Crypto Negotiated Ransom Demand
              <span class="text-danger" v-if="negotiated_ransom_demand === ''"
                >*</span
              >
              <template v-if="currencyUnit !== ''"
                >({{ currencyUnit }})</template
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="cryptonegotiatedransomdemand"
              id="cryptonegotiatedransomdemand"
              v-model="crypto_negotiated_ransom_demand"
            />
            <div class="error" v-if="$v.crypto_negotiated_ransom_demand.$error">
              Either Crypto Negotiated Ransom Demand/ in Dollars is required
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{
              'form-group--error': $v.negotiated_ransom_demand.$error,
            }"
          >
            <label for="NegotiatedRansomDemand">
              Negotiated Ransom Demand
              <span
                class="text-danger"
                v-if="crypto_negotiated_ransom_demand === ''"
                >*</span
              >
            </label>
            <input
              type="number"
              class="form-control"
              name="NegotiatedRansomDemand"
              id="NegotiatedRansomDemand"
              v-model="negotiated_ransom_demand"
            />
            <div class="error" v-if="$v.negotiated_ransom_demand.$error">
              Either Crypto Negotiated Ransom Demand/ in Dollars is required
            </div>
          </div>
          <div
            class="form-group col-12"
            :class="{
              'form-group--error': $v.final_ransom_payment_files.$error,
            }"
          >
            <label>
              Final Ransom Demand Screenshots(jpg/png)
              <span class="text-danger">*</span>
            </label>
            <div
              v-for="index in final_ransom_payment_files.length + 1"
              :key="index"
            >
              <FileUpload
                @fileSelected="finalRansomFileSelected"
                @fileRemoved="finalRansomFileRemoved"
                :unique-key="`finalransomfile${index}`"
              />
            </div>
            <div
              class="error"
              v-if="
                !$v.final_ransom_payment_files.required &&
                $v.final_ransom_payment_files.$error
              "
            >
              Please upload a valid file
            </div>
            <div
              class="error"
              v-if="
                $v.final_ransom_payment_files.$error &&
                !$v.final_ransom_payment_files.unique
              "
            >
              Files must be Unique
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="paymentrequesteddate">Payment requested date</label>
          <div>
            <date-picker
              v-model="paymentrequesteddate"
              format="DD-MMM-YYYY"
              value-type="format"
            ></date-picker>
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.walletid.$error }"
        >
          <label for="walletid" class="form__label">
            Wallet ID
            <span class="text-danger">*</span>
          </label>
          <div class="d-flex">
            <input
              type="text"
              class="form-control"
              name="walletid"
              id="walletid"
              v-model.trim="$v.walletid.$model"
            />
            <button
              class="btn bgprimarycolor text-white ml-2"
              id="btncheckwallet"
              @click="checkWalletId"
              :disabled="walletid === ''"
            >
              Check
            </button>
          </div>

          <div v-if="walletProjects">
            <div v-if="walletProjects.length > 0" class="mt-2">
              <h6>
                The same wallet id has been used in the following projects:
              </h6>
              <ul>
                <li v-for="project in walletProjects" :key="project.projectId">
                  {{ project.name }}
                </li>
              </ul>
            </div>
            <div v-else class="mt-2">
              <h6>The wallet id is never used.</h6>
            </div>
          </div>
          <div class="error" v-if="!$v.walletid.required && $v.walletid.$error">
            Wallet type is required
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.wallet_screenshots.$error }"
        >
          <label>
            Upload Wallet Details Screenshots (jpg/png)
            <span class="text-danger">*</span>
          </label>
          <div v-for="index in wallet_screenshots.length + 1" :key="index">
            <FileUpload
              @fileSelected="walletImageSelected"
              @fileRemoved="walletImageRemoved"
              :unique-key="`walletimage${index}`"
            />
          </div>
          <div
            class="error"
            v-if="
              !$v.wallet_screenshots.required && $v.wallet_screenshots.$error
            "
          >
            Please upload a valid file
          </div>
          <div
            class="error"
            v-else-if="
              $v.wallet_screenshots.$error && !$v.wallet_screenshots.unique
            "
          >
            Files must be unique.
          </div>
        </div>
        <div class="form-group">
          <label for="pol" class="align-middle"
            >Has Proof of Life been Completed?
            <span class="text-danger">*</span></label
          >
          <select
            id="haspolcompleted"
            v-model="has_proof_of_life_completed"
            class="custom-select"
          >
            <option selected></option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div
            class="error"
            v-if="
              !$v.has_proof_of_life_completed.required &&
              $v.has_proof_of_life_completed.$error
            "
          >
            Please select an option
          </div>
        </div>
        <div
          class="form-group"
          v-if="has_proof_of_life_completed === 'true'"
          :class="{ 'form-group--error': $v.pol_files.$error }"
        >
          <label
            >Proof of Life Screenshots (jpg/png)
            <span class="text-danger">*</span></label
          >
          <div v-for="index in pol_files.length + 1" :key="index">
            <FileUpload
              @fileSelected="polFileSelected"
              @fileRemoved="polFileRemoved"
              :unique-key="`polss${index}`"
            />
          </div>
          <div
            class="error"
            v-if="!$v.pol_files.required && $v.pol_files.$error"
          >
            Please upload a valid Proof of Life Screenshot
          </div>
          <div class="error" v-if="$v.pol_files.$ && !$v.pol_files.unique">
            Files must be Unique
          </div>
        </div>
        <div
          class="form-group"
          v-else-if="has_proof_of_life_completed === 'false'"
          :class="{ 'form-group--error': $v.confirmation_communication.$error }"
        >
          <label>
            Reason Why Proof of Life is Not Needed
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="confirmation_communication"
          />
          <div
            class="error"
            v-if="
              $v.confirmation_communication.$error &&
              !$v.confirmation_communication.required
            "
          >
            Please enter Confirmation Communication Message
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.client_physical_address.$error }"
        >
          <label>
            Client Physical Address
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="client_physical_address"
          />
          <div class="error" v-if="$v.client_physical_address.$error">
            Client Physical Address is Required
          </div>
        </div>
        <div class="row">
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.carrier_emails.$error }"
          >
            <label>
              Carrier Details
              <span class="text-danger">*</span>
            </label>
            <div v-for="(carrier, index) in carrier_emails" :key="index">
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control mb-2"
                  v-model="carrier.email"
                  placeholder="Email"
                  @change="
                    checkEmail($event.target.value, 'carrier_emails', index)
                  "
                />
                <input
                  type="text"
                  class="form-control ml-2"
                  placeholder="Full Name"
                  v-model.trim="carrier.full_name"
                />
                <font-awesome-icon
                  class="fa-2x text-success ml-2"
                  :icon="['fas', 'plus-circle']"
                  title="Add new Email"
                  @click="addNewPathNode(carrier_emails, 'carrier')"
                  v-if="index == carrier_emails.length - 1"
                />
                <font-awesome-icon
                  class="fa-2x text-danger ml-2"
                  :icon="['fas', 'minus-circle']"
                  v-if="carrier_emails.length > 1"
                  @click="removePathNode(carrier_emails, index)"
                />
              </div>
              <div
                class="error"
                v-if="
                  $v.carrier_emails.$each[index].$error &&
                  !$v.carrier_emails.$each[index].email.required &&
                  !$v.carrier_emails.$each[index].full_name.required
                "
              >
                Both Email and Full Name are required.
              </div>
              <div
                class="error"
                v-else-if="
                  $v.carrier_emails.$each[index].$error &&
                  !$v.carrier_emails.$each[index].email.email
                "
              >
                Please enter a Valid Email
              </div>
              <div
                class="error"
                v-else-if="
                  $v.carrier_emails.$each[index].$error &&
                  !$v.carrier_emails.$each[index].email.required
                "
              >
                Carrier Email is Required
              </div>
              <div
                class="error"
                v-else-if="
                  $v.carrier_emails.$each[index].$error &&
                  !$v.carrier_emails.$each[index].full_name.required
                "
              >
                Full Name is Required
              </div>
            </div>
          </div>
          <div
            class="form-group col-6"
            :class="{ 'form-group--error': $v.arete_emails.$error }"
          >
            <label>
              Arete Emails
              <span class="text-danger">*</span>
            </label>
            <div v-for="(email, index) in arete_emails" :key="index">
              <div class="d-flex">
                <multiselect
                  v-model="email.email"
                  :options="arete_master_emails"
                  label="mail"
                  track-by="mail"
                  class="mb-2"
                  placeholder="Select email"
                ></multiselect>

                <font-awesome-icon
                  class="fa-2x text-success ml-2"
                  :icon="['fas', 'plus-circle']"
                  title="Add new Email"
                  @click="addNewPathNode(arete_emails, 'areteuser')"
                  v-if="index == arete_emails.length - 1"
                />
                <font-awesome-icon
                  class="fa-2x text-danger ml-2"
                  :icon="['fas', 'minus-circle']"
                  v-if="arete_emails.length > 1"
                  @click="removePathNode(arete_emails, index)"
                />
              </div>
              <div
                class="error"
                v-if="
                  $v.arete_emails.$each[index].$error &&
                  !$v.arete_emails.$each[index].email.required
                "
              >
                Arete Email is Required
              </div>
              <div
                class="error"
                v-else-if="
                  $v.arete_emails.$each[index].$error &&
                  !$v.arete_emails.$each[index].email.email
                "
              >
                Please enter a Valid Email
              </div>
              <div
                class="error"
                v-else-if="$v.arete_emails.$each[index].$error"
              >
                User should be from Arete
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.client_emails.$error }"
        >
          <label>
            Client Details
            <span class="text-danger">*</span>
          </label>
          <div
            v-for="(client, index) in client_emails"
            :key="index"
            class="mb-2"
          >
            <div class="d-flex align-items-center mb-2">
              <div class="input-group w-50">
                <div class="input-group-prepend">
                  <div class="input-group-text text-black">
                    <input
                      type="checkbox"
                      v-model="client.is_primary"
                      data-title="Is Primary?"
                      class="mr-2"
                    />
                    Is Primary
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="client.email"
                  PlaceHolder="Email"
                  @change="
                    checkEmail($event.target.value, 'client_emails', index)
                  "
                />
              </div>
              <div class="ml-2 w-50">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Full Name"
                  v-model="client.full_name"
                />
              </div>
              <font-awesome-icon
                class="fa-2x text-danger ml-2"
                :icon="['fas', 'minus-circle']"
                title="Remove new Email"
                v-if="client_emails.length > 1"
                @click="removePathNode(client_emails, index)"
              />
              <font-awesome-icon
                class="fa-2x text-success ml-2"
                :icon="['fas', 'plus-circle']"
                title="Add new Email"
                @click="addNewPathNode(client_emails, 'client')"
                v-if="index == client_emails.length - 1"
              />
            </div>
            <div
              class="error"
              v-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.required &&
                !$v.client_emails.$each[index].full_name.required
              "
            >
              Both Client Email and Full Name are Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.email
              "
            >
              Please enter a Valid Email
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].email.required
              "
            >
              Client Email is Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.client_emails.$each[index].$error &&
                !$v.client_emails.$each[index].full_name.required
              "
            >
              Full Name is Required
            </div>
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.counsel_emails.$error }"
        >
          <label>
            Counsel Details
            <span class="text-danger">*</span>
          </label>
          <div v-for="(counsel, index) in counsel_emails" :key="index">
            <div class="d-flex align-items-center mb-2">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <span class="mr-2 text-black" v-if="!counsel.is_associate">
                      <input
                        type="checkbox"
                        data-title="Is Partner?"
                        v-model="counsel.is_partner"
                        @click="makeCounselAsPartner(index)"
                        class="align-middle"
                      />
                      Is Partner?</span
                    >
                    <span class="mr-2 text-black" v-if="!counsel.is_partner">
                      <input
                        type="checkbox"
                        data-title="Is Associate?"
                        v-model="counsel.is_associate"
                        @click="makeCounselAsAssociate(index)"
                        class="align-middle"
                      />
                      Is Associate?</span
                    >
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="counsel.email"
                  placeholder="Email"
                  @change="
                    checkEmail($event.target.value, 'counsel_emails', index)
                  "
                />
              </div>
              <input
                type="text"
                class="form-control ml-2"
                placeholder="Full Name"
                v-model="counsel.full_name"
              />
              <font-awesome-icon
                class="fa-2x text-success ml-2"
                :icon="['fas', 'plus-circle']"
                title="Add new Email"
                @click="addNewPathNode(counsel_emails, 'counsel')"
                v-if="index == counsel_emails.length - 1"
              />
              <font-awesome-icon
                class="fa-2x text-danger ml-2"
                :icon="['fas', 'minus-circle']"
                v-if="counsel_emails.length > 1"
                @click="removePathNode(counsel_emails, index)"
              />
            </div>
            <div
              class="error"
              v-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.required &&
                !$v.counsel_emails.$each[index].full_name.required
              "
            >
              Both Counsel Email and Full Name are Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.email
              "
            >
              Please enter a Valid Email
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].email.required
              "
            >
              Counsel Email is Required
            </div>
            <div
              class="error"
              v-else-if="
                $v.counsel_emails.$each[index].$error &&
                !$v.counsel_emails.$each[index].full_name.required
              "
            >
              Full Name is Required
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Notes about Threat Actor</label>
          <textarea
            class="form-control"
            v-model="notes_about_threat_actor"
          ></textarea>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3 mb-3 align-items-baseline">
        <label class="mr-2" v-if="walletProjects == null"
          >Validate wallet id to create a Request.</label
        >
        <button
          class="btn bgprimarycolor text-white"
          @click="createWalletRequest"
          :disabled="walletProjects == null"
          id="createwalletrequest"
        >
          Create
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { required, email, requiredIf } from "vuelidate/lib/validators";
import walletService from "../services/walletService";
import projectService from "../services/projectService";
import Multiselect from "vue-multiselect";
import { EventBus } from "../EventBus";
import FileUpload from "./FileUpload";
import SOWDetails from "./SOWDetails";
import userService from "@/services/userService";
import moment from "moment";

export default {
  name: "EditDetails",
  components: { DatePicker, Multiselect, FileUpload, SOWDetails },
  props: ["requestId"],
  created() {
    EventBus.$emit("toast", {
      title: "",
      message: "Fetching Custom Fields and Emails Master data",
      variant: "success",
    });

    Promise.all([
      projectService.getCustomFields(),
      userService.getUsers(),
      walletService.getWalletRequest(this.requestId),
    ]).then((result) => {
      this.$store.commit("addCustomFields", result[0].data.data);
      this.arete_master_emails = result[1].data.data;
      const wallet_details = result[2].data.data;
      this.projectname = wallet_details.projectDetails.name;
      this.cryptotype = wallet_details.cryptoType;
      this.variant_name = wallet_details.variant.split(",");
      this.carrier_name = wallet_details.carrier;
      this.threat_actor_email_address = wallet_details.threatActorEmailAddress;
      this.tor_chat_link = wallet_details.torChatLink;
      this.client_domain_name = wallet_details.clientDomainName;
      this.ransom_payment_reason = wallet_details.ransomPaymentReason;
      this.crypto_original_ransom_demand =
        wallet_details.cryptoOriginalRansomDemand;
      this.crypto_negotiated_ransom_demand =
        wallet_details.cryptoNegotiatedRansomDemand;
      this.original_ransom_demand = wallet_details.OriginalRansomDemand;
      this.negotiated_ransom_demand = wallet_details.NegotiatedRansomDemand;
      this.paymentrequesteddate = moment(
        wallet_details.paymentRequestedDate
      ).format("DD-MMM-YYYY");
      this.walletid = wallet_details.walletId;
      this.has_proof_of_life_completed = wallet_details.polDetails.isCompleted;
      this.confirmation_communication =
        wallet_details.polDetails.confirmationCommunication;
      this.client_physical_address = wallet_details.clientPhysicalAddress;
      this.notes_about_threat_actor = wallet_details.notesAboutThreatActor;
      this.carrier_emails = wallet_details.carrierDetails.map((c) => {
        return {
          email: c.email,
          full_name: c.fullName,
        };
      });
      this.arete_emails = wallet_details.areteUserDetails.map((c) => {
        return { email: { mail: c.email } };
      });
      this.client_emails = wallet_details.clientDetails.map((c) => {
        return {
          is_primary: c.isPrimary,
          email: c.email,
          full_name: c.fullName,
        };
      });
      this.counsel_emails = wallet_details.counselDetails.map((c) => {
        return {
          is_partner: c.isPartner,
          is_associate: c.isAssociate,
          email: c.email,
          full_name: c.fullName,
        };
      });
    });
  },
  methods: {
    createWalletRequest(e) {
      this.$v.$touch();
      setTimeout(() => {
        if (this.$v.$invalid) {
          this.scrollToLatestError();
        } else {
          e.target.disabled = true;
          this.$bvModal
            .msgBoxConfirm(
              "Please confirm that you want to create Wallet Request",
              {
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                cancelVariant: "danger",
                okTitle: "Yes",
                cancelTitle: "No",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              }
            )
            .then((value) => {
              if (value) {
                this.requestData = new FormData();
                this.requestData.append(
                  "ProjectDetails.Name",
                  this.selectedProject.title
                );
                this.requestData.append(
                  "ProjectDetails.ProjectId",
                  this.selectedProject.id
                );

                this.requestData.append("CryptoType", this.cryptotype);
                this.requestData.append("Variant", this.variant_name.join(","));
                this.requestData.append("Carrier", this.carrier_name);
                this.requestData.append(
                  "ThreatActorEmailAddress",
                  this.threat_actor_email_address
                );
                this.requestData.append("TorChatLink", this.tor_chat_link);
                this.requestData.append(
                  "ClientDomainName",
                  this.client_domain_name
                );
                this.requestData.append(
                  "RansomPaymentReason",
                  this.ransom_payment_reason
                );
                this.wallet_screenshots.forEach((w, index) => {
                  this.requestData.append(`WalletImages`, w);
                });
                this.requestData.append("WalletId", this.walletid);
                this.requestData.append(
                  "PaymentRequestedDate",
                  this.paymentrequesteddate
                );
                this.requestData.append(
                  "CryptoOriginalRansomDemand",
                  this.crypto_original_ransom_demand
                );
                this.requestData.append(
                  "CryptoNegotiatedRansomDemand",
                  this.crypto_negotiated_ransom_demand
                );
                this.requestData.append(
                  "OriginalRansomDemand",
                  this.original_ransom_demand
                );
                this.requestData.append(
                  "NegotiatedRansomDemand",
                  this.negotiated_ransom_demand
                );
                this.initial_ransom_payment_files.forEach((f, index) => {
                  this.requestData.append(`InitialRansomPaymentFiles`, f);
                });
                this.final_ransom_payment_files.forEach((f, index) => {
                  this.requestData.append(`FinalRansomPaymentFiles`, f);
                });

                this.requestData.append(
                  "POLDetails.IsCompleted",
                  this.has_proof_of_life_completed === "true"
                );
                this.requestData.append(
                  "POLDetails.ConfirmationCommunication",
                  this.confirmation_communication
                );
                this.pol_files.forEach((f, index) => {
                  this.requestData.append(`POLDetails.Screenshots`, f);
                });

                this.requestData.append(
                  "ClientPhysicalAddress",
                  this.client_physical_address
                );
                this.carrier_emails.forEach((c, i) => {
                  this.requestData.append(
                    `CarrierDetails[${i}].Email`,
                    c.email
                  );
                  this.requestData.append(
                    `CarrierDetails[${i}].FullName`,
                    c.full_name
                  );
                });

                this.handleCustomFieldUpdate(
                  this.carrier_emails[0].email,
                  594255
                );
                this.handleCustomFieldUpdate(
                  this.carrier_emails[0].full_name,
                  582065
                );

                this.arete_emails.forEach((c, i) => {
                  this.requestData.append(
                    `AreteUserDetails[${i}].Email`,
                    c.email.mail
                  );
                  this.requestData.append(
                    `AreteUserDetails[${i}].FullName`,
                    c.email.displayName
                  );
                });

                this.client_emails.forEach((c, i) => {
                  this.requestData.append(`ClientDetails[${i}].Email`, c.email);
                  this.requestData.append(
                    `ClientDetails[${i}].IsPrimary`,
                    c.is_primary
                  );
                  this.requestData.append(
                    `ClientDetails[${i}].FullName`,
                    c.full_name
                  );
                });

                if (this.client_emails[0]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[0].email,
                    747235
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[0].full_name,
                    747225
                  );
                }

                if (this.client_emails[1]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[1].email,
                    747255
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[1].full_name,
                    747245
                  );
                }

                if (this.client_emails[2]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[2].email,
                    747275
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[2].full_name,
                    747265
                  );
                }

                if (this.client_emails[3]) {
                  this.handleCustomFieldUpdate(
                    this.client_emails[3].email,
                    747295
                  );
                  this.handleCustomFieldUpdate(
                    this.client_emails[3].full_name,
                    747285
                  );
                }

                this.counsel_emails.forEach((c, i) => {
                  this.requestData.append(
                    `CounselDetails[${i}].Email`,
                    c.email
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].FullName`,
                    c.full_name
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].IsPartner`,
                    c.is_partner
                  );
                  this.requestData.append(
                    `CounselDetails[${i}].IsAssociate`,
                    c.is_associate
                  );
                });

                const partner_counsel = this.counsel_emails.find(
                  (e) => e.is_partner
                );
                const associate_counsel = this.counsel_emails.find(
                  (e) => e.is_associate
                );

                if (partner_counsel) {
                  this.handleCustomFieldUpdate(partner_counsel.email, 681225);
                  this.handleCustomFieldUpdate(
                    partner_counsel.full_name,
                    747215
                  );
                }

                if (associate_counsel) {
                  this.handleCustomFieldUpdate(associate_counsel.email, 681235);
                  this.handleCustomFieldUpdate(
                    associate_counsel.full_name,
                    747205
                  );
                }

                this.requestData.append(
                  "NotesAboutThreatActor",
                  this.notes_about_threat_actor
                );

                this.requestData.append(
                  "HasWalletIdBeenUsedEarlier",
                  this.walletProjects !== null && this.walletProjects.length > 0
                );

                this.updated_custom_fields.forEach((f, i) => {
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].WorkspaceCustomFieldId`,
                    f.id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].CustomFieldId`,
                    f.custom_field_id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].WorkspaceId`,
                    f.subject_id
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Value`,
                    f.display_value
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Name`,
                    f.custom_field_name
                  );
                  this.requestData.append(
                    `UpdatedCustomFields[${i}].Type`,
                    f.type
                  );
                });

                EventBus.$emit("toast", {
                  title: "",
                  message: "Creating Wallet Request",
                  variant: "success",
                });
                var el$ = document.getElementById("createwalletrequest");
                el$.innerHTML = "Creating...";
                el$.style.animation = "fadinganimation 1s infinite";
                var that = this;
                walletService
                  .createWalletRequest(this.requestData)
                  .then((response) => {
                    el$.innerHTML = "Create";
                    el$.style.animation = "";
                    that.$store.commit("addWalletRequest", response.data.data);
                    EventBus.$emit("toast", {
                      title: "",
                      message: "Successfully created Wallet Request",
                      variant: "success",
                    });
                    that.$router.push({ name: "dashboard-view" });
                  })
                  .catch((err) => {
                    e.target.disabled = false;
                    el$.innerHTML = "Create";
                    el$.style.animation = "";
                  });
              } else {
                e.target.disabled = false;
              }
            });
        }
      }, 50);
    },
    checkWalletId() {
      if (this.walletid) {
        var el$ = document.getElementById("btncheckwallet");
        el$.innerHTML = "Checking...";
        el$.style.animation = "fadinganimation 1s infinite";
        walletService
          .CheckWalletId(this.walletid)
          .then((response) => {
            el$.innerHTML = "Check";
            el$.style.animation = "";
            this.walletProjects = response.data.data;
          })
          .catch((err) => {});
      } else {
      }
    },
    walletImageSelected(file) {
      this.wallet_screenshots.push(file);
    },
    polFileSelected(file) {
      this.pol_files.push(file);
    },
    initialRansomFileSelected(file) {
      this.initial_ransom_payment_files.push(file);
    },
    finalRansomFileSelected(file) {
      this.final_ransom_payment_files.push(file);
    },
    walletImageRemoved(fileName, callback) {
      let index = this.wallet_screenshots.findIndex((s) => s.name === fileName);
      this.wallet_screenshots.splice(index, 1);
      callback();
    },
    polFileRemoved(fileName, callback) {
      let index = this.pol_files.findIndex((s) => s.name === fileName);
      this.pol_files.splice(index, 1);
      callback();
    },
    initialRansomFileRemoved(fileName, callback) {
      let index = this.initial_ransom_payment_files.findIndex(
        (s) => s.name === fileName
      );
      this.initial_ransom_payment_files.splice(index, 1);
      callback();
    },
    finalRansomFileRemoved(fileName, callback) {
      let index = this.final_ransom_payment_files.findIndex(
        (s) => s.name === fileName
      );
      this.final_ransom_payment_files.splice(index, 1);
      callback();
    },
    // handleVariants(value) {
    //   if (
    //     this.variants.filter(
    //       (v) => v.toLowerCase().indexOf(value.toLowerCase()) !== -1
    //     ).length === 0
    //   ) {
    //     this.variants.shift();
    //     this.variants.unshift(value);
    //   }
    // },
    addNewPathNode(list, type) {
      switch (type) {
        case "client":
          list.push({ email: "", is_primary: false, full_name: "" });
          break;
        case "counsel":
          list.push({
            email: "",
            full_name: "",
            is_partner: false,
            is_associate: false,
          });
          break;
        case "carrier":
        case "areteuser":
          list.push({ email: "", full_name: "" });
          break;
        default:
          break;
      }
    },
    removePathNode(list, index) {
      list.splice(index, 1);
    },
    checkEmail(email, model, index) {
      this.$v[model].$touch();
    },
    getCustomFieldValue(custom_field) {
      const cField = this.project_custom_fields.find(
        (c) => c.custom_field_name.trim() === custom_field
      );
      if (cField) {
        return cField.display_value;
      }
      return "";
    },
    getCustomFieldValueById(id) {
      const cField = this.project_custom_fields.find(
        (c) => c.custom_field_id === id
      );
      if (cField) {
        return cField.display_value;
      }
      return "";
    },
    formClientPhysicalAddress() {
      const address = this.getCustomFieldValueById(602135);
      const city = this.getCustomFieldValueById(602145);
      const state = this.getCustomFieldValueById(602155);
      const country = this.getCustomFieldValueById(602165);
      const postal_code = this.getCustomFieldValueById(747185);
      let address_str = [address, city, state, country, postal_code];
      return address_str.filter((a) => a !== "").join(",");
    },
    handleCustomFieldUpdate(value, field_id) {
      const index = this.updated_custom_fields.findIndex(
        (c) => c.custom_field_id === field_id
      );
      if (index !== -1) {
        this.updated_custom_fields.splice(index, 1);
      }
      let cur_value = this.getCustomFieldValueById(field_id);
      if (field_id === 689325 || field_id === 572015) {
        cur_value = cur_value.replace(/[^0-9.]+/g, "");
      }
      if (value !== cur_value) {
        let field = this.project_custom_fields.find(
          (c) => c.custom_field_id === field_id
        );
        let cField = { ...field };
        if (Array.isArray(value)) {
          cField.display_value = value.join(",");
        } else {
          cField.display_value = value;
        }
        this.updated_custom_fields.push(cField);
      }
    },
    makeCounselAsPartner(index) {
      this.counsel_emails.forEach((e) => {
        e.is_partner = false;
      });
      this.counsel_emails[index].is_partner = !this.counsel_emails[index]
        .is_partner;
    },
    makeCounselAsAssociate(index) {
      this.counsel_emails.forEach((e) => {
        e.is_associate = false;
      });
      this.counsel_emails[index].is_associate = !this.counsel_emails[index]
        .is_associate;
    },
  },
  watch: {
    walletid(w) {
      this.walletProjects = null;
      this.handleCustomFieldUpdate(w, 572035);
    },
    carrier_name(c) {
      this.handleCustomFieldUpdate(c, 598475);
    },
    variant_name(v) {
      this.handleCustomFieldUpdate(v, 571045);
    },
    ransom_payment_reason(r) {
      this.handleCustomFieldUpdate(r, 650875);
    },
    cryptotype(c) {
      this.handleCustomFieldUpdate(c, 682855);
    },
    crypto_original_ransom_demand(c) {
      this.handleCustomFieldUpdate(c, 566695);
    },
    crypto_negotiated_ransom_demand(c) {
      this.handleCustomFieldUpdate(c, 566675);
    },
    original_ransom_demand(o) {
      this.handleCustomFieldUpdate(o, 689325);
    },
    negotiated_ransom_demand(n) {
      this.handleCustomFieldUpdate(n, 572015);
    },
  },
  computed: {
    ...mapState({
      customFields: (state) => state.customFields,
    }),
    currencyUnit() {
      return this.cryptotype == "" ? "" : this.cryptotype;
    },
    variants: {
      get() {
        return this.$store.getters.customFieldChoicesById(571045);
      },
      set(value) {
        this.variants = value;
      },
    },
    carriers() {
      return this.$store.getters.customFieldChoicesById(598475);
    },
    crypto_types() {
      return this.$store.getters.customFieldChoicesById(682855);
    },
    ransom_payment_reasons() {
      return this.$store.getters.customFieldChoicesById(650875);
    },
  },
  data() {
    return {
      projectname: "",
      cryptotype: "",
      walletid: "",
      paymentrequesteddate: "",
      crypto_original_ransom_demand: "",
      crypto_negotiated_ransom_demand: "",
      original_ransom_demand: "",
      negotiated_ransom_demand: "",
      projects: [],
      selectedProject: {},
      walletProjects: null,
      isLoading: false,
      wallet_screenshots: [],
      requestData: "",
      variant_name: "",
      threat_actor_email_address: "",
      carrier_name: "",
      client_domain_name: "",
      carrier_emails: [
        {
          email: "",
          full_name: "",
        },
      ],
      arete_emails: [
        {
          email: "",
        },
      ],
      client_emails: [
        {
          email: "",
          is_primary: false,
          full_name: "",
        },
      ],
      counsel_emails: [
        {
          email: "",
          full_name: "",
          is_partner: false,
          is_associate: false,
        },
        {
          email: "",
          full_name: "",
          is_partner: false,
          is_associate: false,
        },
      ],
      has_proof_of_life_completed: "",
      confirmation_communication: "",
      pol_files: [],
      client_physical_address: "",
      notes_about_threat_actor: "",
      initial_ransom_payment_files: [],
      final_ransom_payment_files: [],
      arete_master_emails: [],
      tor_chat_link: "",
      breadcrumb_items: [
        {
          text: "Dashboard",
          to: { name: "dashboard-view" },
        },
        {
          text: "Edit Request",
          active: true,
        },
      ],
      ransom_payment_reason: "",
      project_custom_fields: [],
      updated_custom_fields: [],
    };
  },
  validations: {
    selectedProject: { required },
    cryptotype: { required },
    walletid: { required },
    wallet_screenshots: {
      required,
      unique(screenshots) {
        let names = this.wallet_screenshots.map((s) => s.name);
        return new Set(names).size === names.length;
      },
    },
    variant_name: { required },
    has_proof_of_life_completed: { required },
    threat_actor_email_address: {
      required: requiredIf(function () {
        return this.tor_chat_link === "";
      }),
      email,
    },
    tor_chat_link: {
      required: requiredIf(function () {
        return this.threat_actor_email_address === "";
      }),
    },
    carrier_name: { required },
    client_domain_name: { required },
    carrier_emails: {
      required,
      $each: { email: { required, email }, full_name: { required } },
    },
    pol_files: {
      required: requiredIf(function () {
        return this.has_proof_of_life_completed === "true;";
      }),
      unique(files) {
        let names = this.pol_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
    },
    confirmation_communication: {
      required: requiredIf(function () {
        return this.has_proof_of_life_completed === "false";
      }),
    },
    client_physical_address: { required },
    arete_emails: {
      required,
      $each: { email: { mail: { required, email } } },
    },
    client_emails: {
      required,
      $each: { email: { required, email }, full_name: { required } },
    },
    counsel_emails: {
      required,
      $each: { email: { required, email }, full_name: { required } },
    },
    initial_ransom_payment_files: {
      required,
      unique(files) {
        let names = this.initial_ransom_payment_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
    },
    final_ransom_payment_files: {
      required,
      unique(files) {
        let names = this.final_ransom_payment_files.map((s) => s.name);
        return new Set(names).size === names.length;
      },
    },
    crypto_original_ransom_demand: {
      required: requiredIf(function () {
        return this.original_ransom_demand === "";
      }),
    },
    crypto_negotiated_ransom_demand: {
      required: requiredIf(function () {
        return this.negotiated_ransom_demand === "";
      }),
    },
    original_ransom_demand: {
      required: requiredIf(function () {
        return this.crypto_original_ransom_demand === "";
      }),
    },
    negotiated_ransom_demand: {
      required: requiredIf(function () {
        return this.crypto_negotiated_ransom_demand === "";
      }),
    },
    ransom_payment_reason: { required },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#crequestcontainer {
  width: 85%;
  margin: auto;
  margin-top: 40px;
  transition: 0.5s;
}

.blurfilter {
  filter: blur(10px);
}

#amountcontainer {
  justify-content: space-between;
}

.mx-datepicker {
  width: 100% !important;
}

.form-group--error {
  scroll-margin-top: 70px;
}

.error {
  animation-name: shakeError;
  animation-fill-mode: forwards;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
  display: block;
  color: #f57f6c;
}

@keyframes shakeError {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0);
  }
}

.multiselect {
  min-height: 30px !important;
}

.multiselect__single,
.multiselect__input,
.multiselect__element {
  line-height: 11px !important;
  font-size: 13.333px !important;
}

.multiselect__tags {
  min-height: 30px !important;
  height: 30px !important;
}

.multiselect__tag {
  margin-top: -4px;
  font-size: 12px;
}

.multiselect__select {
  height: 30px !important;
}

.multiselect__placeholder {
  position: absolute;
  top: 5px;
}

.multiselect__content-wrapper {
  overflow: auto !important;
}

.loading {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  color: $primary-color;
}

.w-50 {
  width: 50% !important;
}
</style>